module.exports = __webpack_public_path__ + "static/gödel-escher-bach-70120b7e28a62283824849c08cf71cbb.jpg";